(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
   document.body.addEventListener('click', e => {
        var parent;
        if(e.target.classList.contains('product-single__info-collapsible-toggle')) {
          parent = e.target.parentElement;
        }
        if(e.target.classList.contains('product-single__info-collapsible-toggle-icon') || 
        e.target.classList.contains('product-single__info-collapsible-title')
        ) {
          parent = e.target.parentElement.parentElement;
        }
        if(parent){
          if(parent.classList.contains('open')) {
            parent.classList.remove('open');
          } else {
            parent.classList.add('open');
          }
        }
       
      })

  } catch(e) { console.error(e); }
})();
})();
